import styled from "styled-components";

export const CmpTextAreaInput = styled.div`
`;